import styled from "styled-components";
import { DynamicHeading } from "../DynamicHeading/DynamicHeading";

export type SubheadingConfig = {
  titleTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "div";
} & React.HTMLAttributes<HTMLElement>;

export const Subheading = styled(DynamicHeading).attrs<SubheadingConfig>(
  ({ titleTag = "p" }) => ({
    titleTag,
    as: titleTag,
  })
)<SubheadingConfig>`
  font-family: var(--typography-subheading-font-family);
  font-weight: var(--typography-subheading-font-weight);
  font-size: var(--typography-subheading-font-size-desktop);
  line-height: var(--typography-subheading-line-height);
  letter-spacing: var(--typography-subheading-letter-spacing);

  @media (max-width: 768px) {
    font-size: var(--typography-subheading-font-size-mobile);
  }

  margin: 0;
  word-wrap: break-word;
  overflow-wrap: anywhere;
`;
